module.exports = __webpack_public_path__ + "img/veterinaire.a46f9c62.png";